import { OutboundCampaign } from '@/types/TOutbound';
import { TSmartVariableDefinition } from '@/types/TSmartCRM';
import { convertFilterGroupsForBackend } from '@/utils/SmartCRM/filterUtils';

const flattenEnrollmentRules = (backendFilterGroups: any[]) => {
	const flattenedRules: any[] = [];

	backendFilterGroups.forEach((group) => {
		if (group.filters && Array.isArray(group.filters)) {
			group.filters.forEach((filter: any) => {
				flattenedRules.push({
					variableId: filter.variableId,
					operator: filter.operator,
					value: Array.isArray(filter.value) ? filter.value.join(',') : String(filter.value),
					fieldType: filter.fieldType,
				});
			});
		}
	});

	return flattenedRules;
};

export const convertToBackendPayload = (
	campaign: OutboundCampaign,
	fields: TSmartVariableDefinition[],
	agentId?: string,
) => {
	let enrollmentRules: any[] = [];

	if (campaign.enrollmentRules && campaign.enrollmentRules.length > 0) {
		const firstRule = campaign.enrollmentRules[0];

		if (firstRule && typeof firstRule === 'object' && firstRule.id) {
			const backendFilterGroups = convertFilterGroupsForBackend(campaign.enrollmentRules, fields);
			enrollmentRules = flattenEnrollmentRules(backendFilterGroups);
		} else {
			enrollmentRules = campaign.enrollmentRules;
		}
	}

	const convertedWorkflows = (campaign.workflows || []).map((workflow) => ({
		id: workflow.id,
		type: workflow.type,
		createdFor: workflow.createdFor || 'Inbound',
	}));

	return {
		agentId,
		name: campaign.name,
		goal: campaign.goal,
		schedule: campaign.schedule,
		workflows: convertedWorkflows,
		maxRetries: campaign.maxRetries,
		enrollmentRules,
	};
};
